export default {"src":"/_next/static/media/VarDelivery_small.5ce03da3.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};